import React from 'react';

const spinnerStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
};

const wheelStyle = {
  width: '48px',
  height: '48px',
  border: '6px solid #eee',
  borderTop: '6px solid #3498db',
  borderRadius: '50%',
  animation: 'spin 1s linear infinite',
};

const styleSheet = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`;

const SuspenseFallback = () => (
  <div style={spinnerStyle}>
    <style>{styleSheet}</style>
    <div style={wheelStyle}></div>
  </div>
);

export default SuspenseFallback;
